import { createFileRoute, redirect } from '@tanstack/react-router'

import { firstAreaUnder } from '@/constants/system-navigation'
import { currentUserRoles } from '@/stores/use-app-store'

/** The area has no page of its own; it opens on the first page the role may
 *  open, which is the first page of the first group the header offers them. */
export const Route = createFileRoute('/internal/system/')({
  beforeLoad: () => {
    throw redirect({ to: firstAreaUnder(undefined, currentUserRoles()) })
  },
})
